<template>
    <section
        v-if="content"
        class="c-integrate"
    >
        <h2 class="c-integrate__title">
            {{ content.title }}
        </h2>
        <div class="c-integrate__wrapper">
            <div class="c-integrate__compability">
                <h3>
                    {{ content.custom.field1 }}
                </h3>
                <p>
                    {{ content.custom.field2 }}
                </p>
                <div class="c-integrate__logos">
                    <img
                        v-for="comp in compability"
                        :key="comp.id"
                        :src="comp.link"
                        :alt="comp.title"
                        class="logos"
                    >
                </div>
            </div>
           
            <div class="c-integrate__third-party">
                <h3>
                    {{ content.custom.field3 }}
                </h3>
                <p>
                    {{ content.custom.field4 }}
                </p>
                <div
                    class="c-integrate__logos"
                >
                    <img
                        v-for="third in thirdParty"
                        :key="third.id"
                        :src="third.link"
                        :alt="third.title"
                    >
                </div>
            </div> <div class="c-integrate__code-samples">
                <h3>
                    {{ content.custom.field5 }}
                </h3>
                <p>
                    {{ content.custom.field6 }}
                </p>
                <div
                    class="c-integrate__logos"
                >
                    <img
                        v-for="code in codeSamples"
                        :key="code.id"
                        :src="code.link"
                        :alt="code.title"
                    >
                </div>
            </div>
            <div class="c-integrate__cta">
                <y-button
                    :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                    :href="content.custom['button-link']"
                    :to="content.custom['button-link']"
                    :content="content.custom['button-title']"
                    color="primary"
                    size="medium"
                    flat
                    no-padding
                />
            </div>
        </div>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name: 'CallToAction',

        props: {
            content: Object,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                thirdParty : '',
                compability: '',
                codeSamples: '',
            };
        },

        /**
         * @inheritdoc
         */
        created() {
            this.seperateContent();
        },

        methods: {
            isLink,

            /**
             * seperate contents to integrates
             */
            seperateContent() {
                this.compability = this.content.albums.filter((item) => item.group === 'album');
                this.codeSamples = this.content.albums.filter((item) => item.group === 'album3');
                this.thirdParty = this.content.albums.filter((item) => item.group === 'album2');
            },
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
